import { useParams } from 'react-router-dom';

const useIntIdParams = (): number => {
    const { id = '0' } = useParams();

    return +id;
};

export default useIntIdParams;
